var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be5ad61d-bb6e-4397-b21c-f505a645fa39",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "18px",
    height: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t#be5ad61d-bb6e-4397-b21c-f505a645fa39{fill:#87c7f7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.6,0,0,114.6,0,256S114.6,512,256,512,512,397.4,512,256,397.4,0,256,0Zm0,400a31.59,31.59,0,0,1-32-32c0-18,13.1-32,32-32a32,32,0,0,1,0,64Zm69.1-142L280,286v2a24,24,0,0,1-48,0V272a24.67,24.67,0,0,1,12-21l57-34a21.44,21.44,0,0,0,11-19c0-12-10.9-22-22.9-22H238a21.62,21.62,0,0,0-22,22,24,24,0,0,1-48,0c0-39,31-70,69.1-70h51.1c40.8,0,71.8,31,71.8,70C360,222,347,245,325.1,258Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuestion);
export default __webpack_public_path__ + "static/media/ico-question.bc1ebbf54341e3f94a3ed4a8fe21895e.svg";
export { ForwardRef as ReactComponent };